import { ButtonPrimaryTextOnly } from '@creditas-ui/react';
import React from 'react';
import { resetFilters } from '../../../store/reducers/ejn-filters';

const ResetFiltersComponent: React.FC = () => {
  return (
    <ButtonPrimaryTextOnly
      onClick={resetFilters}
      size="medium"
      width="flexible"
    >
      Clear
    </ButtonPrimaryTextOnly>
  );
};

const ResetFilters = React.memo(ResetFiltersComponent);

export default ResetFilters;
